"use client";

import { c as _c } from "react/compiler-runtime";
import { useChains } from "@opensea/app-kit";
import { useEffect, useRef } from "react";
import { useTranslations } from "use-intl";
import { Button } from "../../../../../components/Button";
import { TransactionFullScreen } from "../../../../../components/TransactionFullScreen";
import { useTransactionStatus } from "../../../../../polychain/hooks/useTransactionStatus";
import { FlowActions } from "../../../../../stores/flowStore";
export function TokenClaimStatus(t0) {
  const $ = _c(35);
  const {
    transactionIdentifier,
    tokenImageUrl
  } = t0;
  const t = useTranslations("wallet.TokenClaimStatus");
  const {
    getChain
  } = useChains();
  const hasCalledOnSuccess = useRef(false);
  const chain = getChain(transactionIdentifier.chain);
  const blockExplorer = chain?.blockExplorer;
  let t1;
  if ($[0] !== transactionIdentifier.chain || $[1] !== transactionIdentifier.transactionHash) {
    t1 = {
      transaction: {
        chain: transactionIdentifier.chain,
        hash: transactionIdentifier.transactionHash
      }
    };
    $[0] = transactionIdentifier.chain;
    $[1] = transactionIdentifier.transactionHash;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const transactionStatus = useTransactionStatus(t1);
  let t2;
  let t3;
  if ($[3] !== transactionStatus) {
    t2 = () => {
      if (transactionStatus === "success" && !hasCalledOnSuccess.current) {
        hasCalledOnSuccess.current = true;
        FlowActions.onSuccess();
      }
    };
    t3 = [transactionStatus];
    $[3] = transactionStatus;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  if (transactionStatus === "pending") {
    let t4;
    if ($[6] !== t) {
      t4 = t("pending.description");
      $[6] = t;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    let t5;
    if ($[8] !== tokenImageUrl) {
      t5 = tokenImageUrl ? [tokenImageUrl] : [];
      $[8] = tokenImageUrl;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    let t6;
    if ($[10] !== t) {
      t6 = t("pending.title");
      $[10] = t;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    let t7;
    if ($[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
      t7 = <TransactionFullScreen body={t4} images={t5} loading={true} title={t6} />;
      $[12] = t4;
      $[13] = t5;
      $[14] = t6;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    return t7;
  }
  const transactionUrl = blockExplorer?.transactionUrlTemplate.replace(":hash", transactionIdentifier.transactionHash);
  if (transactionStatus === "error") {
    let t4;
    if ($[16] !== t) {
      t4 = t("failed.description");
      $[16] = t;
      $[17] = t4;
    } else {
      t4 = $[17];
    }
    let t5;
    if ($[18] !== tokenImageUrl) {
      t5 = tokenImageUrl ? [tokenImageUrl] : [];
      $[18] = tokenImageUrl;
      $[19] = t5;
    } else {
      t5 = $[19];
    }
    let t6;
    if ($[20] !== t) {
      t6 = t("failed.title");
      $[20] = t;
      $[21] = t6;
    } else {
      t6 = $[21];
    }
    return <TransactionFullScreen body={t4} bottom={<Button href={transactionUrl} target="_blank" variant="secondary">{t("viewTransaction", {
        explorerName: blockExplorer?.name ?? ""
      })}</Button>} images={t5} monochrome={true} title={t6} />;
  }
  const T0 = TransactionFullScreen;
  const T1 = Button;
  const t4 = "_blank";
  const t5 = "secondary";
  const t6 = t("viewTransaction", {
    explorerName: blockExplorer?.name ?? ""
  });
  let t7;
  if ($[22] !== T1 || $[23] !== t6 || $[24] !== transactionUrl) {
    t7 = <T1 href={transactionUrl} target={t4} variant={t5}>{t6}</T1>;
    $[22] = T1;
    $[23] = t6;
    $[24] = transactionUrl;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== tokenImageUrl) {
    t8 = tokenImageUrl ? [tokenImageUrl] : [];
    $[26] = tokenImageUrl;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== t) {
    t9 = t("success.title");
    $[28] = t;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== T0 || $[31] !== t7 || $[32] !== t8 || $[33] !== t9) {
    t10 = <T0 bottom={t7} confetti={true} images={t8} title={t9} />;
    $[30] = T0;
    $[31] = t7;
    $[32] = t8;
    $[33] = t9;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  return t10;
}